import * as React from "react";
const ExclaimIcon2 = (props:any) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 13.75C9.22587 13.75 10.7884 13.0504 11.9194 11.9194C13.0504 10.7884 13.75 9.22587 13.75 7.5C13.75 5.77413 13.0504 4.21162 11.9194 3.08058C10.7884 1.94956 9.22587 1.25 7.5 1.25C5.77413 1.25 4.21162 1.94956 3.08058 3.08058C1.94956 4.21162 1.25 5.77413 1.25 7.5C1.25 9.22587 1.94956 10.7884 3.08058 11.9194C4.21162 13.0504 5.77413 13.75 7.5 13.75Z"
      stroke="#6D77A0"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 11.5625C7.93147 11.5625 8.28125 11.2127 8.28125 10.7812C8.28125 10.3498 7.93147 10 7.5 10C7.06853 10 6.71875 10.3498 6.71875 10.7812C6.71875 11.2127 7.06853 11.5625 7.5 11.5625Z"
      fill="#6D77A0"
    />
    <path
      d="M7.5 3.75V8.75"
      stroke="#6D77A0"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ExclaimIcon2;
